import Image from "next/image";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { cn } from "@/services/styles/cn";

interface SpeakerProps {
  name: string;
  image: {
    url: string;
    alt: string;
    width: number;
    height: number;
  };
  description: string;
  tags: string[];
  className?: string;
}

export function Speaker({ name, image, description, tags, className }: SpeakerProps) {
  return (
    <div className={cn("flex flex-col gap-4 rounded-2xl bg-white px-4 pt-4 pb-6", className)}>
      <div className="flex gap-4 md:flex-col">
        <div className="max-h-[80px] min-h-[80px] min-w-[80px] max-w-[80px] overflow-hidden rounded-lg md:max-h-[400px] md:max-w-[400px]">
          <Image src={image.url} alt={image.alt} width={image.width} height={image.height} />
        </div>
        <div>
          <ul className="flex flex-wrap gap-2">
            {tags.map((tag, index) => (
              <li
                key={tag}
                className={`rounded-full px-3 py-2 font-medium text-dodger-blue-700 text-sm ${index % 2 === 0 ? "bg-white-linen-50" : "bg-blue-50"}`}
              >
                {tag}
              </li>
            ))}
          </ul>
          <p className="mt-6 font-serif text-2xl md:mb-2">{name}</p>
        </div>
      </div>
      <SanitizedContent as="div" content={description} />
    </div>
  );
}
